///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";
import { getSpotNotes, putSpotNotesRead } from "../api/api";
import types from "../helpers/types";
import { clearSpotLeg } from "./spotLegSlice";
import { setSpotLegUpdates, removeSpotLeg } from "./spotLegsSlice";

export const initialState = {
  getRequestStatus: types.requestStatuses.initial,
  notes: [],
  putRequestStatus: types.requestStatuses.initial,
};

const spotNotesSlice = createSlice({
  name: "spotNotesSlice",
  initialState,
  reducers: {
    requestSpotNotes: (state) => {
      state.getRequestStatus = types.requestStatuses.inProgress;
    },
    receiveSpotNotesSuccess: (state, { payload }) => {
      state.notes = payload.notes;
      state.getRequestStatus = types.requestStatuses.success;
    },
    receiveSpotNotesFailure: (state) => {
      state.getRequestStatus = types.requestStatuses.failure;
    },
    resetSpotNotes: (state) => {
      state.notes = [];
      state.getRequestStatus = types.requestStatuses.initial;
      state.putRequestStatus = types.requestStatuses.initial;
    },
    requestSpotNotesMarkedRead: (state) => {
      state.putRequestStatus = types.requestStatuses.inProgress;
    },
    spotNotesMarkedReadSuccess: (state) => {
      state.putRequestStatus = types.requestStatuses.success;
    },
    spotNotesMarkedReadFailure: (state) => {
      state.putRequestStatus = types.requestStatuses.failure;
    },
  },
});

export const {
  requestSpotNotes,
  receiveSpotNotesSuccess,
  receiveSpotNotesFailure,
  resetSpotNotes,
  requestSpotNotesMarkedRead,
  spotNotesMarkedReadSuccess,
  spotNotesMarkedReadFailure,
} = spotNotesSlice.actions;

export const fetchSpotNotes =
  (spotLegId, triggerNotification) => async (dispatch) => {
    let notes;

    dispatch(requestSpotNotes());
    try {
      notes = await getSpotNotes(spotLegId);
    } catch (e) {
      if (triggerNotification && e.response?.status === 403) {
        dispatch(removeSpotLeg(spotLegId));
        dispatch(clearSpotLeg());
        triggerNotification(types.notifications.legUnavailable);
      }
      dispatch(receiveSpotNotesFailure());
      return;
    }
    dispatch(receiveSpotNotesSuccess({ notes }));
  };

export const markSpotNotesRead =
  (spotLegId, unreadNotes) => async (dispatch) => {
    dispatch(requestSpotNotesMarkedRead());
    try {
      await putSpotNotesRead(spotLegId, unreadNotes);
      dispatch(spotNotesMarkedReadSuccess());
      dispatch(fetchSpotNotes(spotLegId));
      dispatch(
        setSpotLegUpdates({ spotLegId, updates: { hasUnreadNotes: false, noteReadStatus: types.noteReadStatus.read } })
      );
    } catch (e) {
      dispatch(spotNotesMarkedReadFailure());
      return;
    }
  };

export const spotNotesReducer = spotNotesSlice.reducer;
